<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Pendaftaran Semen IBVK">
      <w-card class="modern-card">
        <div class="ternakan-container">
          <!-- QR Code -->
          <div class="ternakan-left">
            <div class="grow">
              <figure class="qrcode">
                <vue-qrcode :value="'se/' + data.id" width="200" />
                <img
                  class="qrcode__image"
                  src="/images/logov2.png"
                  alt="Chen Fengyuan"
                />
              </figure>
            </div>
          </div>

          <!-- Info Section -->
          <div class="ternakan-right">
            <ul class="info-list">
              <div class="info-columns">
                <div class="info-group">
                  <li>
                    <b>Tarikh Pendaftaran</b> : &nbsp;
                    <span>{{ $zutil.dateformat(data.tarikh) }}</span>
                  </li>
                  <li>
                    <b>Nombor Batch</b> : &nbsp; <span>{{ data.no_batch }}</span>
                  </li>
                  <li>
                    <b>ID Ternakan</b> : &nbsp; <span>{{ data.id_ternakan }}</span>
                  </li>
                  <li>
                    <b>Nama Ternakan</b> : &nbsp; <span>{{ data.nama_ternakan }}</span>
                  </li>
                </div>

                <div class="info-group">
                  <li>
                    <b>Tarikh Pengeluaran</b> : &nbsp;
                    <span>{{ $zutil.dateformat(data.tarikh_pengeluaran) }}</span>
                  </li>
                  <li>
                    <b>Bilangan Straw Didaftarkan</b> : &nbsp;
                    <span>{{ data.bil_straw_daftar }}</span>
                  </li>
                  <li>
                    <b>Harga Perstraw (RM)</b> : &nbsp; <span>{{ data.harga }}</span>
                  </li>
                  <li>
                    <b>Negara</b> : &nbsp; <span>{{ data.negara }}</span>
                  </li>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </w-card>

      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import VueQrcode from "vue-qrcode";

export default {
  extends: ZResource,
  components: { VueperSlides, VueperSlide, VueQrcode },
  props: { id: [Array, Object, String] },
  data() {
    return {
      resourceurl: "se.pendaftaran",
      crumbs: [
        { label: this.$page.props.app_name, route: "/home" },
        { label: "Pengurusan Semen Beku", route: "/se" },
        { label: "Pendaftaran Semen IBVK", route: "/se/pendaftaran" },
        { label: "Papar", route: "/se/pendaftaran/" + this.id },
      ],
      data: { id: 0 },
    };
  },
  methods: {
    getData() {
      this.$zcomm
        .get(this.api_service + "se_pendaftaran/show/" + this.id, {})
        .then((res) => {
          this.data = res;
        });
    },
    tutup() {
      this.$inertia.visit(window.route("se.pendaftaran.index"));
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  margin-top: -12px;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 15%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
}

/* 🌟 Base Card */
.modern-card {
  padding: 28px;
  border-radius: 18px;
  background: linear-gradient(145deg, #ffffff, #f5f8fc);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

/* 📦 Layout */
.ternakan-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.ternakan-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* 📋 Info Section */
.ternakan-right {
  width: 100%;
  max-width: 950px;
}

ul.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 22px;
}

.info-group {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
  padding: 20px;
  transition: transform 0.3s ease;
}

.info-group:hover {
  transform: translateY(-3px);
}

.info-group li {
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #e0e5ec;
  padding: 6px 0;
  color: #444;
  font-size: 15px;
  line-height: 1.6;
}

.info-group li:last-child {
  border-bottom: none;
}

.info-group li b {
  color: #333;
  font-weight: 600;
  min-width: 210px;
  text-align: left;
}

.info-group li span {
  flex: 1;
  text-align: left;
  font-weight: 500;
  color: #333;
}

/* 📱 Responsif */
@media (max-width: 768px) {
  .info-columns {
    grid-template-columns: 1fr;
  }
}
</style>
